import { MenuItem } from '@chakra-ui/react'
import { FC } from 'react'
import { GrDocumentCsv } from 'react-icons/gr'

import useFollowUpReabAlert from '@hook/alerts/use-followup-reab'
import useTools from '@hook/shared/use-tools'

import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'
const ActionExcelAlertFollowUpReabExport: FC<ILayoutToolsExportAction> = () => {
  const { isDisabled } = useTools()
  const { exportData } = useFollowUpReabAlert()
  return (
    <MenuItem
      p="2px 12px"
      fontSize="sm"
      bgColor="white"
      _hover={{ bg: 'gray.400' }}
      isDisabled={isDisabled}
      onClick={exportData}
      icon={<GrDocumentCsv />}
    >
      Exportar para Tabela
    </MenuItem>
  )
}

export default ActionExcelAlertFollowUpReabExport
